import React from 'react';
export const Footer = () => {
  return <footer className="bg-black border-t border-white/10 py-12" data-id="element-132">
      <div className="container mx-auto px-4" data-id="element-133">
        <div className="grid md:grid-cols-4 gap-8" data-id="element-134">
          <div data-id="element-135">
            <h3 className="font-orbitron text-lg tracking-wider mb-6" data-id="element-136">
              <span className="text-white" data-id="element-137">LEX</span>
              <span className="text-zinc-400" data-id="element-138">SQUIRE</span>
            </h3>
            <p className="text-zinc-400 text-sm font-light" data-id="element-139">
              The hybrid platform where humans and AI work together to handle
              every aspect of client intake for law firms.
            </p>
          </div>
          <div data-id="element-140">
            <h4 className="text-white mb-4" data-id="element-141">Platform</h4>
            <ul className="space-y-2 text-zinc-400 text-sm" data-id="element-142">
              <li data-id="element-143">
                <a href="/features" className="hover:text-white transition-colors" data-id="element-144">
                  Features
                </a>
              </li>
              <li data-id="element-145">
                <a href="/integrations" className="hover:text-white transition-colors" data-id="element-146">
                  Integrations
                </a>
              </li>
              <li data-id="element-147">
                <a href="/pricing" className="hover:text-white transition-colors" data-id="element-148">
                  Pricing
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-149">
            <h4 className="text-white mb-4" data-id="element-150">Resources</h4>
            <ul className="space-y-2 text-zinc-400 text-sm" data-id="element-151">
              <li data-id="element-152">
                <a href="https://messagesimproved-c95820de.mintlify.app/guide/introduction" className="hover:text-white transition-colors" data-id="element-153">
                  API
                </a>
              </li>
              <li data-id="element-154">
                <a href="mailto:support@lexsquire.legal" className="hover:text-white transition-colors" data-id="element-155">
                  Support
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-156">
            <h4 className="text-white mb-4" data-id="element-157">Company</h4>
            <ul className="space-y-2 text-zinc-400 text-sm" data-id="element-158">
              <li data-id="element-159">
                <a href="/vision" className="hover:text-white transition-colors" data-id="element-160">
                  About
                </a>
              </li>
              <li data-id="element-161">
                <a href="mailto:info@lexsquire.legal" className="hover:text-white transition-colors" data-id="element-162">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>;
};